<template>
  <div id='questionnaire'>
  	
			<div class="notify" v-if='type'>
				  <img src="../assets/placeholder-happy.png" class="placeholder">
					<div class='title'>小橘袋营养问卷</div>
					<div class="description">来自美国的营养科学家们特别研发的问卷，量身为您定制专属的营养产品。只需5-10分钟，获得崭新的开始。</div>
          <router-link to="/Questions" class='app-btn app-btn-red btn' >开始答题</router-link>
				
			</div>
      <div class="notify" v-if='!type'>
          <img src="../assets/placeholder-happy.png" class="placeholder2">
          <div class='title'>恭喜你！完成问卷</div>
          <div class="description">正在分析结果 <br/>即将根据您的情况生成推荐报告</div>
      </div>
  </div>
</template>


<script>
export default {
  name: 'Questionnaire',
  data:function () {
    return{
      
    }
  },
  beforeCreate:function(options) {
    console.log(this.$route.query.type)
    if(this.$route.query.type==1){
      this.type = true
    }else{
      this.type = false
    }
    console.log(this.type)
  },
  mounted(){
    console.log(this.type)
  }
}
</script> 
<style>
#questionnaire{
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  position: relative;
  background-color: #F4F2F0;
}
.notify {
    position: absolute;
    top:50%;
    left: 50%;
    margin-top:-54vw;
    margin-left: -38.5vw;;
    width: 77vw;
    height: 108vw;
    box-sizing: border-box;
    padding: 10vw 9vw ;
    text-align: center;
    border-radius: 5px;
    box-shadow: 0px 50px 50px -20px rgba(236, 163, 129, 0.288);
    background-color: #fff;
}
.placeholder {
    width: 25vw;
    height: 25vw;
    margin: 0 auto 5vw;
}
.placeholder2 {
    width: 36vw;
    height: 36vw;
    margin: 10vw auto 9vw;
}
.title {
    font-weight: bold;
    height: 9vw;
    line-height: 9vw;
    font-size: 5.5vw;
    letter-spacing:0.2vw;
    margin-bottom: 4vw;
}
.description {
    color:rgba(80, 80, 80, 1);
    font-size: 30rpx;
    line-height: 50rpx;
    padding: 0 69rpx;
    margin-bottom:10vw;
}
.btn{
  margin: 0 auto;
  border-radius: 6vw;
}
</style>